import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getURLParam, getCookie } from './../utils'
interface Base {
  preLogin: boolean
  isLogin: boolean
  isDebug: boolean
  isApp: boolean
  uid: number
}
export const initialState: Base = {
  preLogin: !!getCookie('yyuid'),
  isLogin: false,
  isDebug: getURLParam('debug') === '1',
  isApp: RegExp(/hy|huya/i).test(navigator.userAgent),
  uid: parseInt(getCookie('yyuid') as string, 10) || 0,
}
const base = createSlice({
  name: 'base',
  initialState,
  reducers: {
    setLogin: (state, action: PayloadAction<boolean>) => {
      state.isLogin = action.payload
    },
    setUid: (state, action: PayloadAction<number>) => {
      state.uid = action.payload
    },
  },
})

export const { setLogin, setUid } = base.actions
export default base